<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Induction Modules</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="px-3 py-4">
  <p *ngIf="!inductionService?.data?.modules">
    We could not find any induction material. Please contact {{ utils.getAppName() }} for assistance.
  </p>

  <h6 *ngIf="inductionService?.data?.name">{{ inductionService.data.name }}</h6>
  <div *ngIf="inductionService?.data?.description" [innerHTML]="inductionService?.data?.description | sanitizeHtml"></div>

  <p>
    Click on each of these modules, read the induction and complete all questions.
    You need to save your answers at the end of each module. When all answers are
    saved for each module, you can submit your answers. You will not be able to
    revisit this induction once you submitted your answers. Scroll down to see if
    there are more modules to complete.
  </p>

  <div class="list-group">
    <button
      type="button"
      class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
      *ngFor="let module of inductionService?.data?.modules; let i = index"
      (click)="onOpenModule(i)">
      {{ i + 1 }}. {{ module.name }}
      <span class="d-inline-flex align-items-center">
        <span *ngIf="module?.was_saved" class="badge badge-primary badge-pill mr-3">Saved</span>
        <mat-icon>navigate_next</mat-icon>
      </span>
    </button>
  </div>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="p-3">
    <button
      mat-raised-button
      class="my-2 ml-1 mr-2"
      type="button"
      color="primary"
      [disabled]="!canSubmit()"
      (click)="onSubmitAnswers()">
      Submit Answers
    </button>
</mat-dialog-actions>
